import { createStore, Store } from 'vuex';

import * as c from '@model/const/sites';
import academy from './modules/academy';
import awards from './modules/awards';
import blog from './modules/blog';
import cleverbridge from './modules/cleverbridge';
import config from './modules/config';
import countries from './modules/countries';
import events from './modules/events';
import eventsFeed from './modules/events-feed';
import expressSignup from './modules/express-signup';
import geolocation from './modules/geolocation';
import inapp from './modules/inapp';
import licenses from './modules/licenses';
import locales from './modules/locales';
import pages from './modules/pages';
import partners from './modules/partners';
import partnersLocator from './modules/partners-locator';
import popup from './modules/popup';
import pressReleases from './modules/press-releases';
import pressReleasesFeed from './modules/press-releases-feed';
import products from './modules/products';
import publications from './modules/publications';
import resourceCenter from './modules/resource-center';
import ribbon from './modules/ribbon';
import sense from './modules/sense';
import seo from './modules/seo';
import slapfive from './modules/slapfive';
import slices from './modules/slices';
import solutions from './modules/solutions';
import trial from './modules/trial';
import user from './modules/user';
import vroi from './modules/vroi';
import workday from './modules/workday';

interface AugmentedStore {
    $context: Record<string, any>;
}

export function StoreFactory(context: any, initialState?: any): AugmentedStore {
    const siteID = context.public.siteID;
    const modules = {
        ...(() => {
            switch (siteID) {
                case c.SITE_ID_SOLUTIONS:
                    return {
                        config,
                        slices,
                        solutions,
                        geolocation,
                    };
                case c.SITE_ID_EVENTS:
                    return {
                        config,
                        countries,
                        geolocation,
                        events,
                        licenses,
                        locales,
                        products,
                        slices,
                        seo,
                        trial,
                        user,
                        vroi,
                    };
                case c.SITE_ID_DEVELOPER:
                    return {
                        awards,
                        blog,
                        cleverbridge,
                        config,
                        countries,
                        events,
                        eventsFeed,
                        geolocation,
                        locales,
                        pages,
                        partners,
                        partnersLocator,
                        popup,
                        products,
                        publications,
                        ribbon,
                        slices,
                        trial,
                        user,
                    };
                case c.SITE_ID_SCS:
                    return {
                        awards,
                        blog,
                        cleverbridge,
                        config,
                        countries,
                        events,
                        eventsFeed,
                        geolocation,
                        licenses,
                        locales,
                        pages,
                        partners,
                        partnersLocator,
                        products,
                        publications,
                        slices,
                        trial,
                        user,
                    };
                case c.SITE_ID_TRUEIMAGE:
                    return {
                        awards,
                        blog,
                        cleverbridge,
                        config,
                        countries,
                        events,
                        eventsFeed,
                        geolocation,
                        licenses,
                        locales,
                        pages,
                        partners,
                        partnersLocator,
                        popup,
                        products,
                        publications,
                        ribbon,
                        seo,
                        slices,
                        trial,
                        user,
                    };
                case c.SITE_ID_ACADEMY:
                    return {
                        academy,
                        config,
                        geolocation,
                        slices,
                        user,
                    };
                case c.SITE_ID_WWW:
                default:
                    return {
                        awards,
                        blog,
                        cleverbridge,
                        config,
                        countries,
                        events,
                        eventsFeed,
                        expressSignup,
                        geolocation,
                        inapp,
                        licenses,
                        locales,
                        pages,
                        partners,
                        partnersLocator,
                        popup,
                        pressReleases,
                        pressReleasesFeed,
                        products,
                        publications,
                        resourceCenter,
                        ribbon,
                        sense,
                        seo,
                        slapfive,
                        slices,
                        solutions,
                        trial,
                        user,
                        vroi,
                        workday,
                    };
            }
        })(),
    };

    const store = createStore({
        state: () => ({
            context: {
                public: context.public,
            },
        }),
        ...initialState,
        // eslint-disable-next-line @typescript-eslint/dot-notation
        devtools: typeof window !== 'undefined' && Boolean(window['__VUE_DEVTOOLS_GLOBAL_HOOK__']),
        modules,
    }) as unknown as AugmentedStore;

    const augmented = store as Store<any> & AugmentedStore;
    augmented.$context = context;
    return augmented;
}
